import React,{useState,useRef} from 'react';
import { Header ,Modal} from '../../../../components';
import { Button, message, Input, BackTop } from 'antd';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { useModal } from 'react-modal-hook';
import  Table  from '../components/Table';
import  Form  from '../components/Form';
import { useFetchUser,UseFetchCreateUser,UseFetchUpdateUser} from "../hooks/useFetch";

function Users() {
  const { currentColor } = useStateContext();
  const [ dataEdit, setDataEdit] = useState(null);
  const { data:dataEmployees, isLoading:isLoadingEmployees ,refetch:refetchEmployees } = useFetchUser();
  const {  mutate: fetchUpdateUser } = UseFetchUpdateUser();
  const {  mutateAsync: fetchCreateUser } = UseFetchCreateUser();

  const titlePage = 'พนักงาน';
  const formAddRef = useRef(null); 
  const formEditRef = useRef(null); 
  
  //#region usehook model
  const [showAddModal, hideAddModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formAddRef.current.validateFields();
        
        const result = await fetchCreateUser(value)
        console.log(result);
        // await message.destroy(); 
        await hideAddModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถเพิ่มข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        // await message.destroy(); 
        
      }
    };

    return (
      <Modal
        title={`เพิ่ม ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideAddModal}
      >
        <Form formRef={formAddRef}/>
      </Modal>
    );
  }, []);

  const [showEditModal, hideEditModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formEditRef.current.validateFields();
        console.log(value);
        
        const updateData = {...value,id:dataEdit.id}
        let result = await fetchUpdateUser(updateData)

        await hideEditModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถแก้ไขข้อมูลได้'); 
        //await hideAddModal();
      } finally {
      }
    };

    return (
      <Modal
        title={`แก้ไข ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideEditModal}
      >
        <Form formRef={formEditRef} initialValues={dataEdit}/>
      </Modal>
    );
  }, [dataEdit,isLoadingEmployees]);
    //#endregion


  const handleEdit = (record) => {
     setDataEdit(record);
     showEditModal()
  }

  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <Button onClick={showAddModal} className='bg-blue-500 text-white'>
          เพิ่ม
        </Button>
      </div>
      <Table data={dataEmployees} onEdit={handleEdit} onRefresh={refetchEmployees}  loading={isLoadingEmployees} bordered />
    </div>
  );
}

export default Users;
